const BattleCalc = require( '../BattleCalc' );
const BattleConfig = require( '../../constants/BattleConfig' );
const { logError } = require('../logger')

const KnockbackEvent = function( battleState, actor ) {
	this.eventHandle = 'knockback';
	this.actorId = actor.uid;
	this.movement = true;

	this.execute = ( forceTile, destinationTile ) => {
		try {
			if( !forceTile || !destinationTile ) {
				return;
			}

			this.forceTileId = forceTile.uid;
			this.victimId = destinationTile.uid;
			
			var actorOldTile = battleState.getTileAtCoords( actor.x, actor.y );
			
			actorOldTile.occupied = false;
			actor.x = destinationTile.x;
			actor.y = destinationTile.y;
			destinationTile.occupied = true;

			this.actorOldTileId = actorOldTile.uid;

			this.affectedPieces = [ actor, forceTile, destinationTile ]; 
			battleState.onBattleEvent( this );
		} catch (err) {
      logError(err, {
        module: 'KnockbackEvent',
        func: 'execute',
        actor,
        battleState,
        forceTile,
        destinationTile
      })
		}
	}
}
module.exports = KnockbackEvent
